import { action } from 'typesafe-actions';
import { EntregaNoCdTypes, IEntregaNoCd, IFilter, Pagination } from './types';

export const loadRequest = (
  filtro: IFilter | undefined,
  parceiros: number[],
  codCdd: number,
  pagination?: Pagination,
  sorter?: any
) => action(EntregaNoCdTypes.LOAD_REQUEST, { filtro, parceiros, codCdd, pagination, sorter });

export const loadSuccess = (data: IEntregaNoCd[], pagination: Pagination) =>
  action(EntregaNoCdTypes.LOAD_SUCCESS, { data, pagination });

export const loadFailure = () => action(EntregaNoCdTypes.LOAD_FAILURE);

export const filterEntregaCD = (filter: IFilter | undefined) =>
  action(EntregaNoCdTypes.FILTER_ENTREGACD, { filter });

export const sorterEntregaCD = (ordenacao: any) =>
  action(EntregaNoCdTypes.SORTER_ENTREGACD, { ordenacao });

export const cleanStateEntregaCD = () => action(EntregaNoCdTypes.CLEAN_ENTREGACD, {});
